import { makeSelector } from "../../../testing/index.js";
import { WdioWrapper } from "../../../testing/wdio.js";
import { PaginationSizeSelectors } from "../PaginationSize/paginationSize.selectors.js";
const TestingAttrs = {
  nextPageButton: "data-next-page-button",
  prevPageButton: "data-prev-page-button"
};
const PaginationSelectorsSelectors = {
  nextPageButton: makeSelector("Next page button", TestingAttrs.nextPageButton),
  prevPageButton: makeSelector("Previous page button", TestingAttrs.prevPageButton),
  paginationSizeButton: PaginationSizeSelectors.paginationSizeButton
};
const DsfPaginationSelectorWrapper = (parentSelector) => WdioWrapper(parentSelector, PaginationSelectorsSelectors);
export {
  DsfPaginationSelectorWrapper,
  PaginationSelectorsSelectors,
  TestingAttrs
};
